export default {
	namespaced:true,
	actions:{
        
	},
	mutations:{
        
	},
	state:{
		//判断是否是第一次评估
		isFirst:false,
		//判断是否横屏
		isTrans:false,
		//判断是否绑定过手机号
		phone:'',
		//微信号
		umemo:'',
		//姓名
		realName:'',
		//是否显示loading加载页面
		isLoadingShow:false,
        //是否填写过个人信息
        personalInformationBol:false,
        //判断当前测试到第几节
        itemNum:0,
        //判断当前是否是试玩状态
        isTest:false,
		//判断是否跳过问卷
		isSkip:false,
		//初始进入页面活页url后面的jti
		jti:'',
		//token
		token:'',
		//globalID
		globalId:'',
		//判断是否戴镜
		onEye:1,
		wenJuan:null,
		url:'https://api00.uflycloud.com',
		padUrl:'https://api00.uflycloud.com',
		globalIdUrl:'/globalTimestamp2?',
		appUrl:'/pages/index/index'
	},
	getters:{
        
	},
}